import $ from "jquery";
import Plyr from 'plyr';
import styles from 'plyr/dist/plyr.css';


$(document).ready(function() {
    console.log("test video");
    if ($('.js-player').length > 0) {
        const players = Plyr.setup('.js-player', {
            autoplay: false,
            muted: true,
            loop: {
                active: true // Enable looping for all videos
            },
            youtube: {
                noCookie: true, // Use the privacy-enhanced mode (https://www.youtube-nocookie.com)
                controls: 0, // Hide native controls
                disablekb: 1, // Disable keyboard controls
                modestbranding: 1, // Hide YouTube logo
                rel: 0, // Do not show related videos
                showinfo: 0, // Hide video info
                iv_load_policy: 3, // Hide annotations
                cc_load_policy: 0 // Hide closed captions
            }
        });

        // Ensure YouTube and Vimeo videos are muted and autoplayed
        players.forEach(player => {
            player.on('ready', event => {
                const instance = event.detail.plyr;
        
                // Only play if plyr.config.autoplay = true
                if (instance.config.autoplay) {
                    instance.muted = true;
                    instance.loop = { active: true };
                    instance.play();
                }
            });
        });
        


        //console.log('resize video to fit..');
        function sizeVideo(){
            $('.video-data').each(function(){
                var aspectRatio = $(this).data('ratio');
                var id = $(this).attr('id');
                console.log('ID: ' + id + ', Data Ratio: ' + aspectRatio);
                    var ratioArray = aspectRatio.split(' / ');
                    // Extract the first and second values
                    var widthRatio = parseInt(ratioArray[0], 10);
                    var heightRatio = parseInt(ratioArray[1], 10);
                        
                    var video_ratio = heightRatio / widthRatio;

                    //console.log(' aspectRatio ' . aspectRatio);
                    var $wrapper = $('#' + id + ' .video-con .plyr');
                    //console.log(' $wrapper: ' + $wrapper);
                    var width = $wrapper.width();
                    //console.log(' width ' + width);
                    var height = $wrapper.height(); // Calculate height based on aspect ratio
                    //console.log(' height: ' + height);

                    var wrapper_ratio = height / width;

                    //console.log(' video_ratio: ' + video_ratio + ' wrapper_ratio: ' + wrapper_ratio);

                    var video_width_update = '0px';
                    var video_height_update = '0px';
                    var $video_wrapper = $('#' + id + ' .plyr__video-wrapper');

                    if( video_ratio >= wrapper_ratio){
                        // var video_width_update = width + 'px';
                        // var video_height_update = (width * video_ratio) + 'px';
                        // $video_wrapper.width(video_height_update);
                    } else {
                        var video_width_update = (height / video_ratio) + 'px';
                        var video_height_update = height + 'px !important';
                        //console.log('update video width to ' + video_height_update);
                        $video_wrapper.width(video_width_update);
                    }

                    //console.log(' video_width_update: ' + video_width_update + ' video_height_update: ' + video_height_update);       
            });
        }

        $(window).on('resize', function() {
            sizeVideo();
            //$('.plyr__control[data-plyr="play"]').html('<img class="customplayicon" src="/wp-content/uploads/PlayIcon-1.svg" alt="Play Icon">');
        }).trigger('resize'); 
        

        




    }
    $('.plyr__control[data-plyr="play"]').html('<img class="customplayicon" src="/wp-content/uploads/PlayIcon-1.svg" alt="Play Icon">');

        

});